import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import Shell from "@/components/Shell";
import { visitorNav } from "./VisitorDirectory";
import { Spinner, Overline } from "@/components/Brand";
import { Calendar, MapPin, QrCode, BadgeCheck } from "lucide-react";

export default function VisitorHistory() {
  const [days, setDays] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/visitor/history").then(({ data }) => setDays(data)); }, []);

  const fmtDay = (d) => new Date(d).toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "short" });

  return (
    <Shell nav={visitorNav}>
      <Overline>Your Journey</Overline>
      <h1 className="font-display text-3xl gold-text mt-2">Visited Booths</h1>
      <p className="text-slate-400 text-sm mt-1">Daywise record of every stall you've explored.</p>

      {!days ? <Spinner /> : days.length === 0 ? (
        <p className="text-slate-400 text-center py-16">No visits yet. Start scanning stalls!</p>
      ) : (
        <div className="space-y-8 mt-6">
          {days.map((d) => (
            <div key={d.day} data-testid={`history-day-${d.day}`}>
              <div className="flex items-center gap-2 mb-3">
                <Calendar size={16} className="text-amber-400" />
                <h3 className="font-sub text-sm uppercase tracking-wider text-slate-300">{fmtDay(d.day)}</h3>
                <span className="text-xs text-slate-500">· {d.items.length} booth{d.items.length !== 1 ? "s" : ""}</span>
              </div>
              <div className="space-y-3 border-l border-amber-500/20 pl-4">
                {d.items.map((it, i) => (
                  <div
                    key={i}
                    onClick={() => navigate(`/visitor/exhibitor/${it.exhibitor.id}`)}
                    className="glass rounded-2xl p-4 flex items-center gap-3 card-lift cursor-pointer"
                    data-testid={`history-item-${it.exhibitor.id}`}
                  >
                    <div className="h-12 w-12 rounded-xl bg-cover bg-center shrink-0" style={{ backgroundImage: `url(${it.exhibitor.logo_url})` }} />
                    <div className="flex-1 min-w-0">
                      <div className="text-slate-100 font-medium truncate">{it.exhibitor.name}</div>
                      <div className="flex items-center gap-1 text-xs text-slate-400"><MapPin size={11} /> {it.exhibitor.hall} · {it.exhibitor.booth}</div>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center gap-1 justify-end text-[11px] text-amber-300">
                        {it.visit.source === "badge" ? <BadgeCheck size={12} /> : <QrCode size={12} />}
                        {it.visit.source}
                      </div>
                      {it.visit.count > 1 && <div className="text-[10px] text-slate-500">×{it.visit.count} visits</div>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </Shell>
  );
}
